var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9998 14.2L10.9998 6C10.9998 5.71667 11.0956 5.47917 11.2873 5.2875C11.479 5.09583 11.7165 5 11.9998 5C12.2831 5 12.5206 5.09583 12.7123 5.2875C12.904 5.47917 12.9998 5.71667 12.9998 6L12.9998 14.2L15.8998 11.3C16.0831 11.1167 16.3165 11.025 16.5998 11.025C16.8831 11.025 17.1165 11.1167 17.2998 11.3C17.4831 11.4833 17.5748 11.7167 17.5748 12C17.5748 12.2833 17.4831 12.5167 17.2998 12.7L12.6998 17.3C12.4998 17.5 12.2665 17.6 11.9998 17.6C11.7331 17.6 11.4998 17.5 11.2998 17.3L6.6998 12.7C6.51647 12.5167 6.4248 12.2833 6.4248 12C6.4248 11.7167 6.51647 11.4833 6.6998 11.3C6.88314 11.1167 7.11647 11.025 7.3998 11.025C7.68314 11.025 7.91647 11.1167 8.0998 11.3L10.9998 14.2Z",
    fill: "#DC272D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/DownArrow.ab912f0e3e0564e16460e7748375c9d6.svg";
export { ForwardRef as ReactComponent };